import { useEffect } from "react";

const DEFAULT_TITLE_SUFFIX = "Brandmykitchen";

export function usePageMetadata({
  title,
  description,
  aiActions = "none",
} = {}) {
  useEffect(() => {
    const separator = "·";
    if (title) {
      document.title = `${title} ${separator} ${DEFAULT_TITLE_SUFFIX}`;
    } else {
      document.title = DEFAULT_TITLE_SUFFIX;
    }

    if (description) {
      const descriptionTag = document.querySelector(
        "meta[name='description']"
      );
      if (descriptionTag) {
        descriptionTag.setAttribute("content", description);
      }
    }

    if (aiActions) {
      const aiTag = document.querySelector("meta[name='ai-agent-actions']");
      if (aiTag) {
        aiTag.setAttribute("content", aiActions);
      }
    }
  }, [title, description, aiActions]);
}
